import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { NO_CUSTOM_FIELD_VALUE_ID } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/filters/custom-field-filter';
import customFilterMessages from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/filter-bar/custom-field-filter/messages';
import FilterGroup from '../filter-group/view';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from '../styles.module.css';
import messages from './messages';
import type { Props } from './types';

export default function CustomFieldsFilterGroup({ customFields }: Props) {
	const intl = useIntl();

	if (customFields.length > 0) {
		return (
			<>
				{customFields.map((customField, i) => (
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					<span key={customField.id} className={styles.filterGroupItem}>
						<FilterGroup
							title={customField.title}
							truncateMessageKey={messages.remainingOptions}
							items={[
								...customField.values.map((item) =>
									item.id === NO_CUSTOM_FIELD_VALUE_ID
										? intl.formatMessage(customFilterMessages.noValue)
										: item.name,
								),
							]}
						/>
						{i < customFields.length - 1 ? ', ' : ''}
					</span>
				))}
			</>
		);
	}

	return null;
}
